﻿window.cBuilderEmailWidgetCtrlDateBox = function cBuilderEmailWidgetCtrlDateBox(option) {
    var Me = this;

    // =========================================================
    // Héritage
    // =========================================================

    window.cBuilderEmailWidgetCtrl.call(this, option);


    // =========================================================
    // Propriétés spécifiques
    // =========================================================

    this.nomWidget = "dxwidgetformdatebox"
    this.icone = "fas fa-calendar";
    this.nomBt = "Saisie d'une date";
    this.titleBt = "Permet de saisir une date"
    this.labelCtrl = "Saisissez une date"
    this.typeDevExpress = "dxDateBox"


    // =========================================================
    // Surcharge mCreateElement
    // =========================================================

    var mCreateElementParent = this.mCreateElement;

    this.mCreateElement = function () {

        // Appel de la méthode du parent
        mCreateElementParent.call(Me);

        // =====================================================
        // AJOUT PERSONNEL DE LA CLASSE FILLE
        // =====================================================

        var $Td = Me.mGetTdSaisie();

        Me.mAddCtrlDevExpress()
    };

    this.mAddCtrlDevExpress = function (onValueChangedDevexpress) {
        Me.mGetTdSaisie().empty()
        var ctrl = $("<div class='ctrldevexpress " + Me.mGetTypeCtrlDevexpress() + " electrl" + Me.mGetIndexdevexpress() + " " + (Me.mGetTdSaisie().attr("obligatoire") == "1" ? "obligatoire" : "") + "'/>").appendTo(Me.mGetTdSaisie()).dxDateBox({
            label: (Me.mGetTdSaisie().attr("obligatoire") == "1" ? "* " : "") + Me.mGetTdSaisie().attr("label"),
            labelMode: "floating",
            stylingMode: "outlined", //pour voir la bordure
            acceptCustomValue: false,
            openOnFieldClick:true,
            onValueChanged: function (e) {
                ctrl.element().css("background-color", "")
                ctrl.element().closest("td").css("border-left", "")
                if (onValueChangedDevexpress) onValueChangedDevexpress(ctrl, Me.mGetTdSaisie().attr("indexdevexpress"), Me.mGetTdSaisie().attr("tri"), Me.mGetTdSaisie().attr("typedevexpress"), "", Me.mGetTdSaisie().attr("typchamp"), Me.mGetTdSaisie().attr("label"), e.value)
            }            
        }).dxDateBox("instance")
        ctrl.isEmpty = function () { return ctrl.option("value") == null; }
        return ctrl
    }


    // =========================================================
    // Surcharge mAddCtrlSaisie
    // =========================================================

    var mAddCtrlSaisieParent = this.mAddCtrlSaisie;

    this.mAddCtrlSaisie = function (contentElement) {

        // Appel de la méthode du parent
        mAddCtrlSaisieParent.call(Me, contentElement);

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Nbre carac. maximum:</div>").appendTo(contentElement)
        Me.dx.option("maxLength", parseInt(Me.mGetTdSaisie().attr("maxLength")))
        $("<div/>").appendTo(contentElement).dxSlider({
            min: 10,
            max: 600,
            value: Me.mGetTdSaisie().attr("maxLength"),
            onValueChanged: function (e) {
                Me.mGetTdSaisie().attr("maxLength", e.value)
                Me.dx.option("maxLength", e.value)
                option.onValueChanged()
            },
            tooltip: {
                enabled: true,
                format(value) {
                    return `${value}car.`;
                },
                showMode: 'always',
                position: 'bottom',
            },
            onContentReady: function (e) {
                window.setTimeout(function () { e.component.repaint() }, 0)
            }
        }).dxSlider("instance")

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Hauteur minimal:</div>").appendTo(contentElement)
        Me.dx.option("minHeight", parseInt(Me.mGetTdSaisie().attr("minHeight")))
        $("<div/>").appendTo(contentElement).dxSlider({
            min: 10,
            max: 600,
            value: Me.mGetTdSaisie().attr("minHeight"),
            onValueChanged: function (e) {
                Me.mGetTdSaisie().attr("minHeight", e.value)
                Me.dx.option("minHeight", e.value)
                option.onValueChanged()
            },
            tooltip: {
                enabled: true,
                format(value) {
                    return `${value}px`;
                },
                showMode: 'always',
                position: 'bottom',
            },
            onContentReady: function (e) {
                window.setTimeout(function () { e.component.repaint() }, 0)
            }
        }).dxSlider("instance")
    };
};